import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import SurveyEntry from "./surveys/SurveyEntry";
import ErrorBoundary from "./components/ErrorBoundary";

// ── Global stale-chunk handler ──
// After a deployment, old JS chunk filenames no longer exist on the server.
// Dynamic imports fail with errors that may escape React's error boundaries.
// This global handler catches them and force-reloads the page ONCE.
const RELOAD_KEY = 'ragnarops_global_reload';

function isChunkError(msg: string): boolean {
    return (
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('is not a valid JavaScript MIME type') ||
        msg.includes('Importing a module script failed') ||
        msg.includes('error loading dynamically imported module') ||
        msg.includes('Loading chunk') ||
        msg.includes('ChunkLoadError')
    );
}

function handleChunkReload(): void {
    const last = sessionStorage.getItem(RELOAD_KEY);
    const now = Date.now();
    if (!last || now - Number(last) > 10_000) {
        sessionStorage.setItem(RELOAD_KEY, String(now));
        window.location.reload();
    }
}

// Catch unhandled promise rejections (dynamic import failures)
window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || String(event.reason);
    if (isChunkError(msg)) {
        event.preventDefault();
        handleChunkReload();
    }
});

// Catch synchronous errors (MIME type errors, etc.)
window.addEventListener('error', (event) => {
    const msg = event.message || '';
    if (isChunkError(msg)) {
        event.preventDefault();
        handleChunkReload();
    }
});

// ── Frontend observability ──
// Reports unhandled errors to the backend for monitoring via /health/errors
import { installGlobalHandlers } from './utils/frontend-logger';
installGlobalHandlers();

const rootElement = document.getElementById("root")!;
ReactDOM.createRoot(rootElement).render(
    <ErrorBoundary fallbackMessage="RagnarOps encontró un error inesperado">
        <SurveyEntry />
    </ErrorBoundary>
);
